var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThreewayNew = function SvgThreewayNew(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg823",
    width: 16,
    height: 16,
    viewBox: "0 0 4.233 4.233",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    transform: "translate(0 -292.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1373",
    d: "m2.117 294.35-1.985-1.058v2.116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1404",
    d: "m2.117 294.35 1.984 1.058v-2.116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1406",
    d: "m2.117 294.62-1.059 1.984h2.117z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThreewayNew);
export default ForwardRef;